import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_com = _resolveComponent("head-com")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_foot_com = _resolveComponent("foot-com")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_head_com, { class: "header" }),
    _createVNode(_component_router_view),
    _createVNode(_component_foot_com)
  ], 64))
}